import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faFileImage } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

import { changeNum } from './common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function Character() {
    const [page, setPage] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    let dark = useSelector((state) => { return state.Darkmode.value });

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    const [data, setData] = useState([])

    useEffect(() => {
        setPage(1)
        UpgradeData()
    }, [reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/character', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setData(tmp?.data?.character ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    const [formData, setFormData] = useState({
        NAME: "", // 광고 이름
        PRICE: "", // 리디렉션 URL
        file: '', // 업로드된 파일
    });
    const [imagePreviews, setImagePreviews] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'checkbox') {
            setFormData({ ...formData, [name]: checked });
        } else if (type === 'file') {
            setFormData({ ...formData, file: files });
            handleImagePreview(files);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // 이미지 미리보기 처리 함수
    const handleImagePreview = (files) => {
        const previewArray = Array.from(files).map((file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onloadend = () => {
                    resolve(reader.result); // 파일의 base64 데이터를 resolve
                };
                reader.readAsDataURL(file); // 파일을 base64로 변환
            });
        });

        Promise.all(previewArray).then((images) => {
            setImagePreviews(images); // 미리보기 이미지들을 저장
        });
    };

    const onSubmit = async () => {
        const formDataObj = new FormData();

        formDataObj.append('skinName', formData.NAME);
        formDataObj.append('skinPrice', formData.PRICE); // 리디렉션 URL 추가
        if (formData.file.length > 0) {
            formDataObj.append("file", formData.file[0]);
        } else {
            alert("이미지를 선택하세요.");
            return;
        }

        await axios.post(process.env.REACT_APP_API + "/api/character", formDataObj, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setFormData({
                    NAME: "", // 광고 이름
                    PRICE: "", // 리디렉션 URL
                    file: '', // 업로드된 파일
                })
                setImagePreviews([])
                setReload(e => !e)
            }
            else {
                // setMessage({ msg: "등록에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <div className='main'>
            <Message message={message} />
            <div className='budget-box'>
                <div style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "bold" }}>캐릭터(스킨) 등록</div>
                <div className='create-img-box'>
                    <div className=''>
                        <div className='budget-2'>
                            <div className='budget-1-3'>이미지 첨부</div>
                            <div className='budget-1-2'>
                                <label htmlFor="file" className="form-control file_form" style={{ display: "block" }}>
                                    {formData.file ? Array.from(formData.file).map(file => file.name).join(', ') : "파일선택"}
                                </label>
                                <input className='file-input' type="file" id="file" name="file" style={{ display: "none" }} multiple accept="image/*" onChange={handleChange} />
                            </div>
                        </div>
                        <div className='budget-2'>
                            <div className='budget-1-3'>이름</div>
                            <div className='budget-1-2'>
                                <input className='file-input' style={{ width: "300px" }} type="text" name="NAME" value={formData.NAME || ""} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='budget-2'>
                            <div className='budget-1-3'>금액</div>
                            <div className='budget-1-2'>
                                <input className='file-input' style={{ width: "300px" }} type="number" name="PRICE" value={formData.PRICE || ""} onChange={handleChange} />
                            </div>
                        </div>
                        <div className='ads-btn' onClick={() => onSubmit()}>등록</div>
                    </div>
                    <div className='ads-preImg'>
                        <div>미리보기</div>
                        {
                            imagePreviews.length > 0 &&
                            imagePreviews.map((src, index) => (
                                <img key={index} src={src} alt={`preview ${index}`} className="multipreview" style={{ height: "150px" }} />
                            ))
                        }
                    </div>
                </div>
            </div>
            <div className='table-grid-1' style={{ minHeight: "500px", height: "calc(100vh - 450px)", overflow: "scroll", paddingBottom: "50px" }}>
                {
                    data.map(function (a, i) {
                        return (
                            <MemberItem key={i} item={a} darkname={darkname} dark={dark} setReload={setReload} setMessage={setMessage} />
                        )
                    })
                }
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark, setReload, setMessage }) {
    const [isEditing, setIsEditing] = useState(false);
    const [editedName, setEditedName] = useState(item.skin_name);
    const [editedValue, setEditedValue] = useState(item.skin_value);
    const [editedState, setEditedState] = useState(
        item.skin_state === '1' ? "active" : item.skin_state === '0' ? "hidden" : "inactive"
    );
    const [dianModal, setDiaModal] = useState(false)
    const [clickId, setClickId] = useState([])

    const onSubmitSkinUpdate = async () => {
        const stateValue = editedState === "active" ? '1' : editedState === "hidden" ? '0' : '2';

        await axios.post(process.env.REACT_APP_API + '/api/character/update', {
            skinId: item.id,
            skinName: editedName,
            skinPrice: editedValue,
            skinStatus: stateValue,
        }).then((response) => {
            let tmp = response.data;
            if (tmp?.code === 1000) {
                setReload((e) => !e);
                setIsEditing(false); // 수정 모드 종료
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const handleCancel = () => {
        setEditedName(item.skin_name)
        setEditedValue(item.skin_value); // 원래 값을 복구
        setEditedState(
            item.skin_state === '1' ? "active" : item.skin_state === '0' ? "hidden" : "inactive"
        );
        setIsEditing(false); // 수정 모드 종료
    };

    return (
        <div className='skin-card-1'>
            {dianModal && (<DiaModal darkname={darkname} setDiaModal={setDiaModal} clickId={clickId} setReload={setReload} />)}
            <div className='skin-card-header'>
                <div className='skin-card-header-1'>{item.id}</div>
                <div
                    className='skin-card-header-2'
                    style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}
                >
                    {isEditing ? (
                        <input
                            className="skin-card-1-4"
                            style={{ textAlign: "left" }}
                            value={editedName}
                            onChange={(e) => setEditedName(e.target.value)}
                        />
                    ) : (
                        <div>{item.skin_name}</div>
                    )}
                </div>
            </div>
            <div style={{ position: "relative" }}>
                <img
                    src={item.skin_img}
                    style={{ height: '140px', margin: "10px 0" }}
                />
                <FontAwesomeIcon icon={faFileImage} className='skin-card-icon' style={{ cursor: 'pointer', fontSize: "20px", color: 'gray' }}
                    onClick={() => { setClickId(item); setDiaModal(true) }} />
            </div>
            <div className="skin-card-1-1">
                <div className="skin-card-1-2">Price</div>
                {isEditing ? (
                    <input
                        type="number"
                        className="skin-card-1-4"
                        value={editedValue}
                        onChange={(e) => setEditedValue(e.target.value)}
                    />
                ) : (
                    <div className="skin-card-1-3">{changeNum(item.skin_value)}</div>
                )}
            </div>
            <div className="skin-card-1-1" style={{ marginBottom: "10px" }}>
                <div className="skin-card-1-2">Status</div>
                {isEditing ? (
                    <select
                        className="skin-card-1-4"
                        value={editedState}
                        onChange={(e) => setEditedState(e.target.value)}
                    >
                        <option value="active">Active</option>
                        {/* <option value="hidden">Hidden</option> */}
                        <option value="inactive">Inactive</option>
                    </select>
                ) : (
                    <div className="skin-card-1-3">
                        {item.skin_state === '1'
                            ? "Active"
                            : item.skin_state === '0'
                                ? "Hidden"
                                : "Inactive"}
                    </div>
                )}
            </div>
            {item.id === 1 ? (
                <div className='skin-card-btn' style={{ cursor: "auto" }}>기본</div>
            ) : (
                <>
                    {isEditing ? (
                        <div className="skin-card-buttons">
                            <div className='skin-card-btn' onClick={onSubmitSkinUpdate}>저장</div>
                            <div className='skin-card-btn delete' onClick={handleCancel}>취소</div>
                        </div>
                    ) : (
                        <div className='skin-card-btn delete' onClick={() => setIsEditing(true)}>수정</div>
                    )}
                </>
            )}
        </div>
    );
}

function DiaModal({ darkname, setDiaModal, clickId, setReload }) {
    const [modalFormData, setModalFormData] = useState({
        uploadedFiles: '', // 모달에서 업로드된 파일
    });

    const [modalImagePreviews, setModalImagePreviews] = useState([]); // 모달 전용 미리보기 상태

    const handleModalFileChange = (e) => {
        const { files } = e.target;

        if (files && files.length > 0) {
            setModalFormData({ ...modalFormData, uploadedFiles: files });
            generateModalImagePreviews(files); // 이미지 미리보기 생성
        }
    };

    const generateModalImagePreviews = (files) => {
        const previewArray = Array.from(files).map((file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.readAsDataURL(file); // 파일을 base64로 변환
            });
        });

        Promise.all(previewArray).then((images) => {
            setModalImagePreviews(images); // 모달 내부 상태에만 미리보기 설정
        });
    };

    const handleModalSubmit = async () => {
        // 파일이 선택되지 않았을 때 경고
        if (!modalFormData.uploadedFiles || modalFormData.uploadedFiles.length === 0) {
            alert("이미지를 선택하세요.");
            return;
        }

        // 파일 확장자 확인
        const file = modalFormData.uploadedFiles[0]; // 첫 번째 파일만 처리
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // if (fileExtension !== "png") {
        //     alert("PNG 파일만 업로드 가능합니다.");
        //     return;
        // }

        // FormData 생성
        const formData = new FormData();

        formData.append("skinId", clickId.id);
        formData.append("file", file);

        // API 요청
        await axios
            .post(process.env.REACT_APP_API + '/api/character/update-file', formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                let tmp = response.data;
                if (tmp?.code === 1000) {
                    setDiaModal(false);
                    setReload((e) => !e); // 데이터 새로고침
                }
            })
            .catch((error) => {
                console.error("파일 업로드 중 오류 발생:", error);
            });
    };


    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "800px" }}>
                    <div className='modal-1-header'>스킨 이미지 수정</div>

                    <div className='modal-flex'>
                        <div>
                            <div style={{ height: "50px" }}>기존 이미지</div>
                            <div>
                                <img
                                    src={clickId.skin_img}
                                    style={{ height: '300px' }}
                                    alt="기존 이미지"
                                />
                            </div>
                        </div>
                        <div>
                            <div style={{ height: "50px" }}>
                                <div>변경 이미지</div>
                                <label htmlFor="modalFile" className="form-control file_form" style={{ display: "block", cursor: 'pointer' }}>
                                    {modalFormData.uploadedFiles
                                        ? Array.from(modalFormData.uploadedFiles).map((file) => file.name).join(', ')
                                        : "파일선택"}
                                </label>
                                <input
                                    className='file-input'
                                    type="file"
                                    id="modalFile"
                                    name="modalFile"
                                    style={{ display: "none" }}
                                    multiple
                                    accept="image/*"
                                    onChange={handleModalFileChange}
                                />
                            </div>
                            <div>
                                {modalImagePreviews.length > 0 &&
                                    modalImagePreviews.map((src, index) => (
                                        <img
                                            key={index}
                                            src={src}
                                            alt={`modal preview ${index}`}
                                            className="multipreview"
                                            style={{ height: '300px' }}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>

                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={handleModalSubmit}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setDiaModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Character;